export default __webpack_public_path__ + "media/images/icons/Izquierda-ebbf301d7e8013ca4b7c9f5edc701fcd.svg";